import { WarehouseLocationGroupDetailPage } from '@/features/warehouse-location-group/pages/WarehouseLocationGroupDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/warehouse-location-group/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse_location_group.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseLocationGroupDetailPage,
})
